@if (isLoading()) {
  <div class="loading-container" style="padding-top: 8rem">
    <oui-loading></oui-loading>
  </div>
} @else {
  @if (dossiersJaunesFiltered().length === 0) {
    <span class="text-no-data-dossier-jaune"
      >Aucun élément ne correspond à votre recherche</span
    >
  }
  <div class="text-path-container">
    <span class="text-path-dossier-jaune">{{ currentPath() }}</span>
    @if (currentPath() !== '') {
      <oui-icon
        class="icon-save-shortcut-path icon-save-shortcut-color--{{ isFavPath() }}"
        [title]="
          isFavPath() === 'fav'
            ? 'Chemin enregistré'
            : 'Enregistré ce chemin en raccourci'
        "
        [fill]="true"
        (click)="setShortcutPath()"
        >star</oui-icon
      >
    }
  </div>
  @for (dossierJaune of dossiersJaunesFiltered(); track $index) {
    <oui-button
      class="button-dossier-jaune"
      type="icon"
      oui-dialog-close
      (click)="onFolderOrDocClick(dossierJaune)">
      <div class="content-dossier-jaune">
        @if (dossierJaune.isFolder) {
          <oui-icon class="icon-dossier-jaune" [fill]="true">folder</oui-icon>
          <span class="text-dossier-jaune">{{ dossierJaune.name }}</span>
        }
        @if (!dossierJaune.isFolder) {
          <oui-icon class="icon-fichier">docs</oui-icon>
          <span class="text-dossier-jaune">{{ dossierJaune.name }}</span>
        }
      </div>
    </oui-button>
  }
}
